import React, { useState } from 'react';
import toast from 'react-hot-toast';
import Axios from '../../utils/Axios';
import SummaryAPI from '../../common/SummaryAPI';
import { Link, useNavigate } from 'react-router-dom';
import AxiosToastError from '../../utils/AxiosToastError';

const Login = () => {
    const [data, setData] = useState({
        email: "",
        password: "",
    });

    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const handleChange = e => {
        const { name, value } = e.target;
        setData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await Axios({
                ...SummaryAPI.login,
                data: data
            });

            if (response.data.error) {
                toast.error(response.data.message);
            }

            if (response.data.success) {
                toast.success(response.data.message);
                setData({
                    email: "",
                    password: ""
                });
                navigate("/");
            }

        } catch (error) {
            AxiosToastError(error);
            console.log(error);
        }
    };

    return (
        <div>
            <h1>Login Page</h1>
            <p>This is the login page.</p>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor='email'>Email:</label>
                    <input
                        value={data.email}
                        onChange={handleChange}
                        type='email'
                        id='email'
                        name='email'
                    />
                </div>
                <div>
                    <label htmlFor='password'>Password:</label>
                    <input
                        value={data.password}
                        onChange={handleChange}
                        type='password'
                        id='password'
                        name='password'
                    />
                </div>
                <button type="submit">Login</button>
            </form>
            <p>
                Don't have an account? <Link to={"/register"}>Register</Link>
            </p>
            <p>
                Forgot Password? <Link to={"/forgot-password"}>Set new password</Link>
            </p>
        </div>
    );
};

export default Login;